// extracted by mini-css-extract-plugin
export default {"root":"IconRate_root__l17UU"};